/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////// Mandarin ////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>EngagED家长门户登录流程（内部/外部）</h4>,
    Interrupt_p0: (
        <h5>
            要登录，您将
            <strong>
                <u>不会</u>
            </strong>
            使用您的个人电子邮件。
        </h5>
    ),
    Interrupt_p1: (
        <>
            要登录，您需要输入一个电子邮件地址，该地址由您的{" "}
            <strong>
                <u>用户名</u>
            </strong>{" "}
            加上{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            组成，在接下来的登录屏幕上输入。
            <br />
            例如：如果您的<b>用户名</b>是 <b>jsmith</b>，您将输入{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            。
            <br />
            <br />
            您的密码与您访问 Infinite
            Campus（现有家长）时使用的密码相同，或者您在开放注册账户设置期间创建的密码（外部家长）。
        </>
    ),
    Interrupt_p2: (
        <strong>
            如果您需要用户名或密码方面的帮助，请访问{" "}
            <a href="https://password.dcsdk12.org" target="_blank">
                password.dcsdk12.org
            </a>
            。
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>如果您在按照以上步骤操作后仍无法访问，请联系我们：</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                家长技术支持 - 英语
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                家长技术支持 - 西班牙语
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                家长技术支持 - 中文
            </a>
            <br />
            IT 支持中心：<b>303.387.0001</b>
        </>
    ),
    Interrupt_note: "注意：目前为人父母的学区员工应使用隐身或私密浏览窗口和/或不同的浏览器，按照上述说明进行操作。",
    Interrupt_submit: "继续登录",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "欢迎,",
    Main_Nav_HelpfulLinks: "有用的网址",
    Main_Nav_LogOut: "登出",
    Main_Nav_HelpfulLinks_LI_s1: "联系我的学生的护士",
    Main_Nav_HelpfulLinks_LI_s2: "学术日历",
    Main_Nav_HelpfulLinks_LI_s3: "家长资源",
    Main_Nav_HelpfulLinks_LI_s4: "公交路线",
    Main_Nav_HelpfulLinks_LI_s5: "在线支付",
    Main_Nav_HelpfulLinks_LI_s6: "午餐菜单",
    Main_Nav_Exit: "出口",
    Global_Dashboard: "仪表板",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD 监护人仪表板",
    Breadcrumb_Back: "DCSD Engaged 家长门户",
    Breadcrumb_EPR: "DCSD 存档 EPR",
    Breadcrumb_Translations: "翻译尚在实验阶段",
    Breadcrumb_School_Selection: "学生选校",
    Breadcrumb_New_Student_Create: "创建新学生",
    Breadcrumb_Schools_Making_Offers: "学校正在准备录取通知",
    /// /////////////////////////////////////////////////////////
    /// /////////////// OE //////////////////////////////////////
    /// /////////////////////////////////////////////////////////
    OE_Closed_Title: "公开入学申请窗口已关闭",
    OE_Closed_Text: "公开入学申请窗口现已关闭。请在学区的家长访问窗口期间返回。谢谢。",
    OE_Student_Info_Breadcrumb: "学生与监护人信息",
    OE_Student_Info_Guardian_Title: "监护人当前信息",
    OE_Student_Info_Student_Title: "学生当前信息",
    OE_Student_Info_Email: "电子邮件",
    OE_Student_Info_Address: "地址",
    OE_Student_Info_Phone: "电话",
    OE_Student_Info_Current_School: "当前学校",
    OE_Student_Info_Neighborhood_School: "社区学校",
    OE_Student_Info_Scheduled_School: "明年预定就读学校",
    OE_New_Student: "新学生",
    OE_Unavailable: "不可用",
    OE_Form_FirstName: "学生法定名字 (First Name)",
    OE_Form_FirstName_Description: "请使用出生证明上的学生法定名字",
    OE_Form_MiddleName: "学生法定中间名",
    OE_Form_MiddleName_Description: "请使用出生证明上的学生法定中间名",
    OE_Form_LastName: "学生法定姓氏",
    OE_Form_LastName_Description: "请使用出生证明上的学生法定姓氏",
    OE_Form_Gender: "性别",
    OE_Form_Gender_Male: "男性",
    OE_Form_Gender_Female: "女性",
    OE_Form_Gender_NonBinary: "非二元性别",
    OE_Form_Birthdate: "学生出生日期",
    OE_Form_Month: "月",
    OE_Form_Example: "示例",
    OE_Form_Day: "日",
    OE_Form_Year: "年",
    OE_Form_Clear_Birthdate: "清除出生日期字段",
    OE_Form_Student_Address: "学生法定地址",
    OE_Form_Student_Address_Description:
        "如果您居住在 Douglas 县或 Elbert 县，请开始输入您的地址，并从推荐地址列表中选择您的地址。",
    OE_Form_Search_Address: "搜索地址",
    OE_Form_Apt_Or_Unit: "公寓或单元号",
    OE_Form_Select: "选择",
    OE_Form_Address1: "地址第 1 行",
    OE_Form_Address2: "地址第 2 行",
    OE_Form_City: "城市",
    OE_Form_State: "州",
    OE_Form_Zip: "邮政编码",
    OE_Form_App_For_Grade: "公开入学申请年级",
    OE_Form_App_For_Grade_Description1: "根据您的学生在", // [some variable school year range]
    OE_Form_App_For_Grade_Description2: "学年的年龄",
    OE_Form_App_For_Grade_Description3: (
        <>
            您将申请公开入学至下方<span className="yellow-box">黄色方框</span>中显示的年级。如果“申请年级”不正确，
            请联系我们的选课规划部门 <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> 讨论您的具体
            情况。
            <span className="will-be">
                如果“申请年级”不正确<span className="bold">且</span>您继续进行学校 选择，您的公开入学申请可能会作废。
            </span>
        </>
    ),
    OE_Form_Current_Grade: "当前年级",
    OE_Form_Applying_For_Grade: "申请年级",
    OE_Form_Applying_For_Kindergarten: "该学生将申请下一学年的幼儿园公开入学",
    OE_Form_Applying_For_Kinder_Title: "申请幼儿园",
    OE_Form_Applying_For_Kinder_Body:
        "请确认您想将学生的“申请年级”从一年级调整为幼儿园。如果您在选择了学校后进行此调整，这些学校选择将被删除，您需要重新完成选择。",
    OE_Form_Reasons_For_Leaving: "离开原因",
    OE_Form_Important: "重要",
    OE_Form_Important_Note: "注意：必须选择一个或多个原因",
    OE_Form_Important_Reasons: "离开的原因是什么", // [some variable school name]
    OE_Form_Important_Other: "注意：如果您选择“其他”作为申请理由，您必须输入备注才能提交您的择校申请。",
    OE_Form_Address_Placeholder: "在此开始输入您的地址",
    OE_Buttons_Delete: "删除公开入学申请",
    OE_Buttons_Back_To_Dashboard: "返回仪表板",
    OE_Buttons_Confirm_And_Proceed: "确认并继续",
    OE_Buttons_Cancel: "取消",
    OE_Buttons_Email: "保存并通过电子邮件发送我的选择",
    OE_Dialog_Delete_Title: "删除公开入学申请确认",
    OE_Dialog_Delete_Body1: "请确认您要删除该学生的公开入学申请：", // [some variable student name] - Added a colon to make the appended name grammatically smooth
    OE_Dialog_Delete_Body2: "此操作将删除该学生所有相关的公开入学选校数据。",
    OE_Dialog_Back_Title1: "开放注册信息未保存",
    OE_Dialog_Back_Title2: "导航至监护人仪表板",
    OE_Dialog_Back_Body1: "针对以下学生的开放注册申请尚未保存：",
    OE_Dialog_Back_Body2: "如果您选择返回家长仪表板，您将丢失所有进度。",
    OE_Dialog_Back_Body1a: "您的学生的开放注册申请尚未保存。",
    OE_Schools_Title: "按地区划分的参与学校（最多选择 4 所）",
    OE_Schools_Body:
        "请选择一个区域以查看可供开放入学的学校列表。您必须至少选择一 (1) 所学校，且最多可选择四 (4) 所学校进行开放入学申请。",
    OE_Schools_Curent_Address: "当前地址",
    OE_Schools_Selected: "已选择",
    OE_Schools_My_Schools_Title: "我选择的学校",
    OE_Schools_Selected_Schools_Header: "以下是您为公开招生选择的学校",
    OE_Schools_Selected_Schools_Body: (
        <>
            <h6>
                您已<u>收到</u>以下学校的<u>录取通知</u>：
            </h6>
            <span>
                您可以接受一所学校的录取。所有其他录取将被自动拒绝。您也可以拒绝任何/所有学校的录取。
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_None: "您的学生目前没有任何择校选择",
    OE_Schools_My_Schools_Body:
        '这些是您为开放入学选择的学校。对于您选择的每所学校，您必须点击"选择理由"按钮，告知我们是什么吸引您申请该校的开放入学。请注意，在为每所选定学校输入至少一个申请理由之前，您将无法保存/通过电子邮件发送您的选校方案。如需移除已选学校，请点击学校卡片右上角的垃圾桶图标。',
    OE_Schools_My_Schools_Grade: "申请年级",
    OE_Schools_My_Schools_Status: "状态",
    OE_Schools_My_Schools_Select_Reasons: "选择理由",
    OE_Schools_My_Schools_Reasons_Title: "申请理由",
    OE_Schools_My_Schools_Reasons_Body: (
        <p>
            请注明
            <u>
                <strong>至少一个</strong>
            </u>
            申请该校公开招生的理由。您可以选择所有适用的理由，并可在家长开放申请期间随时更改。
        </p>
    ),
    OE_Schools_My_Schools_Note: "注意：如果您选择“其他”作为申请理由，则必须输入评论才能提交您的选校方案。",
    OE_Schools_My_Schools_Comment: "请输入评论",

    OE_Toast_Email_Error: "无法向监护人发送确认邮件。",
    OE_Toast_IC_Error: "从IC获取学生详细信息时出现问题。",
    OE_Toast_Email: "公开招生择校确认信已发送至 ",
    OE_Toast_Email_Failure: "无法发送择校确认信，因为不存在有效的监护人电子邮箱。",
    OE_Toast_Deleted: "学生的公开招生申请已成功删除。正在跳转至家长控制面板。",
    OE_Toast_Saved: "择校信息已成功保存。正在跳转至家长控制面板。",
    OE_Toast_Offer_Saved: "择校录取的接受和/或拒绝操作已成功保存。",
    OE_Toast_Saved_Emailed: "择校录取的接受和/或拒绝操作已成功保存。正在跳转至家长控制面板。",
    OE_Toast_Update_Error: "更新您的择校信息时出现问题。",
    OE_Toast_Delete_Error: "无法删除学生的公开招生信息。",
    OE_Toast_Student_Updated: "公开招生的学生信息已成功更新。",
    OE_Toast_Data_Error: "加载您的数据时出现问题。请刷新页面并重试。",
    OE_Toast_Valid_Birthdate: "请输入有效的学生出生日期 (MM-DD-YYYY)。",
    OE_Toast_Student_Added: "已成功添加参加公开招生的学生。",
    OE_Toast_OE_Error: "无法删除学生的公开招生信息。",
    OE_Toast_OE_Saved: "已成功保存公开招生的学生信息。",
    OE_Toast_Student_Updated_2: "已成功更新学生信息。",
    OE_Toast_Region_Error: "获取区域学校信息时出现问题",
    OE_Toast_Student_Error: "获取学生详细信息时出现问题",
    OE_Toast_Reasons_Error: "获取申请理由时出现问题",
    OE_Toast_School_Choice_Success: "择校录取的接受和/或拒绝操作已成功保存。",
    OE_Toast_Redirecting: "正在跳转至家长控制面板",
    OE_Dialog_Window_Closed_Title: "公开招生窗口已关闭",
    OE_Dialog_Window_Closed_Body: "公开招生窗口现已关闭。请在学区的家长访问窗口期间再次访问。谢谢。",
    OE_Dialog_Access_Denied_Title: "拒绝访问",
    OE_Dialog_Access_Denied_Body: "对不起，您没有权限查看该学生信息。请返回家长控制面板。",
    OE_Dialog_Ineligible_Title: "出生日期不符合公开招生资格",
    OE_Dialog_Ineligible_Body:
        "根据学生的出生日期，其年龄不在公开招生的范围内。请联系择校规划部门 (Choice Programming department) 探讨具体情况和/或公开招生的其他选项。",
    OE_Dialog_Processing: "正在处理……请稍候",
    OE_Modal_Ineligible: (
        <p>
            根据您输入的出生日期， <span className="age">学生的年龄不在公开招生的范围内</span>。 请联系择校规划部门
            (Choice Programming department) 探讨具体情况和/或公开招生的其他选项。
        </p>
    ),

    OE_Dialog_Incorrect_Info_Title: "学生信息有误",
    OE_Dialog_Incorrect_Info_Body_1: "很抱歉，关于以下学生的信息有误： ", // [variable student name]
    OE_Dialog_Incorrect_Info_Body_2: (
        <>
            <div className="top-sentence">请在开始您的公开招生申请之前遵循以下步骤…… </div>
            <div className="number-container">
                <div className="number">1</div>
                <div className="instruction">
                    请联系您学生的学校要求更正数据。学校或许能立即处理此请求，或者可能需要一些时间。感谢您的耐心等待。
                </div>
            </div>
            <div className="number-container">
                <div className="number">2</div>
                <div className="instruction">
                    一旦您收到学校确认数据更正已完成，请返回此处开始您的公开招生申请，届时您将有机会确认更新后的学生信息准确无误。
                </div>
            </div>
            <div className="number-container">
                <div className="number">3</div>
                <div className="instruction">一旦您确认信息准确无误，即可继续您的公开招生申请。</div>
            </div>
        </>
    ),

    OE_Buttons_Student_Info_Good: "学生信息准确无误",
    OE_Buttons_Student_Info_Incorrect: "学生信息有误",
    OE_Buttons_Save_Changes: "保存更改",
    OE_Buttons_Continue: "继续",
    OE_Buttons_Submit: "提交",
    OE_Buttons_Accept: "接受",
    OE_Buttons_Decline: "拒绝",
    OE_Buttons_Delete: "删除",
    OE_Buttons_Save: "保存",

    OE_Dialog_Choices_Will_Delete_Title: "此前的择校选择将被删除",
    OE_Dialog_Choices_Will_Delete_Body: (
        <p>
            更改该学生的家庭住址可能导致可供公开招生的学校发生变化。因此，此前的择校选择将被删除，保存此更改后您需要重新选择感兴趣的学校。请确认您希望继续，或者点击“取消”并通过
            <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> 联系择校规划团队 (Choice Programming
            team) 以探讨下一步操作。
        </p>
    ),
    OE_Dialog_Birthdate_Change_Body: (
        <p>
            更改该学生的出生日期导致公开招生的申请年级发生变化。因此，保存此更改后您需要重新选择感兴趣的学校。请确认您希望继续。
        </p>
    ),

    OE_Buttons_Accept_Proceed: "接受并继续",
    OE_Buttons_Should_Not_Match: "姓名不应相同",
    OE_Modal_Names_Match_Title: "学生/监护人姓名重复警告",
    OE_Modal_Names_Match_Body_1: "您输入的学生姓名与您监护人账户关联的姓名相同。",
    OE_Modal_Names_Match_Body_2: "输入的学生姓名：",
    OE_Modal_Names_Match_Body_3: "监护人账户姓名：",
    OE_Modal_Names_Match_Note: "注意：不区分大小写",
    OE_Modal_Names_Correction_Title: "重复姓名更正",
    OE_Modal_Names_Correction_Body: (
        <>
            <div>
                您指出您创建的外部监护人账户使用了您的学生的姓名，而不是您自己的姓名。在继续公开招生之前，请致电{" "}
                <strong>
                    <u>303-387-0001</u>
                </strong>{" "}
                联系 IT 支持中心以更正您的账户信息。
            </div>
            <br />
            <div>
                <u>请注意，您为该学生输入的信息将不会被保存，在您的账户信息更正后需要重新输入。</u>
            </div>
        </>
    ),
    OE_Next_Steps: "后续步骤",
    OE_Important_Parent_Info: "重要家长信息",
    OE_Next_Steps_1: "DCSD 学校现已针对所有第一轮申请发出录取通知。请注意，您可能收到也可能未收到您所选学校的录取通知。请注意，在此审核窗口期间，您一次只能接受一份入学录取通知。",
    OE_Next_Steps_2: "DCSD 学校目前正在审核家长接受的录取。",
    OE_Next_Steps_Post: "接受录取通知后，学校将直接联系您，告知入学流程的后续步骤。您无需联系学校，因为这可能会延误流程。"
};
/* eslint-enable */
